import { render, staticRenderFns } from "./index--form.vue?vue&type=template&id=4bf28951&"
import script from "./index--form.vue?vue&type=script&lang=js&"
export * from "./index--form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports